import React from "react";

import WeekPlanLayout from "../components/weekPlan/WeekPlanLayout";

const WeekPlanPage = () => {
    return <div>
        <WeekPlanLayout/>
    </div>;
    };

export default WeekPlanPage;